import React from "react";

import * as S from "./styles";
import { IProps } from "./types";

export const InputLabel: React.FC<IProps> = ({
  children,
  active,
  htmlFor,
  labelBackground,
}: IProps) => {
  return (
    <S.Label {...{ active, htmlFor, labelBackground }}>{children}</S.Label>
  );
};
